<template>
  <v-app>
    <v-snackbar v-model="snackbar">
      {{ msg }}
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-content class="fluid fill-height">
      <HeaderSimple />
      <v-stepper v-model="e1" class="elevation-0 fill-height">
        <v-stepper-header class="elevation-0">
          <v-stepper-step :complete="e1 > 1" step="1">Informações de Login</v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step :editable="edit" :complete="e1 > 2" step="2">Dados do Psicólogo</v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step step="3">Áreas de Atuação</v-stepper-step>
        </v-stepper-header>

        <v-stepper-items>
          <v-stepper-content step="1">
            <v-row class="align-center justify-center">
              <v-col class="col-12">
                <v-form v-model="valid" ref="form2">
                  <v-container>
                    <v-row class="justify-center">
                      <v-col class="col-12 col-sm-6 col-md-5">
                        <v-text-field
                          solo
                          flat
                          label="Email"
                          v-model="email"
                          :rules="emailRules"
                          required
                          background-color="#F7F7F7"
                        ></v-text-field>
                        <v-text-field
                          solo
                          flat
                          label="Confirme o seu Email"
                          v-model="check_email"
                          :rules="emailConfirmationRules"
                          required
                          background-color="#F7F7F7"
                        ></v-text-field>
                        <v-text-field
                          solo
                          flat
                          :label="$t('pageCadastro.labelPassword')"
                          v-model="password"
                          :append-icon="show1 ? 'visibility' : 'visibility_off'"
                          :type="show1 ? 'text' : 'password'"
                          @click:append="show1 = !show1"
                          :rules="passwordRules"
                          required
                          background-color="#F7F7F7"
                        ></v-text-field>
                        <v-text-field
                          solo
                          flat
                          :label="$t('pageCadastro.labelConfirmPassword')"
                          v-model="check_password"
                          :append-icon="show2 ? 'visibility' : 'visibility_off'"
                          :type="show2 ? 'text' : 'password'"
                          @click:append="show2 = !show2"
                          :rules="senhaConfirmationRules"
                          required
                          background-color="#F7F7F7"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row class="flex-column align-center justify-center">
                      <v-checkbox
                        v-model="checkbox"
                        required
                        :rules="[(v) => !!v || 'É necessário aceitar os Termos de Uso e Política de Privacidade para continuar.']"
                      >
                        <template v-slot:label>
                          <div>
                            Li e aceito os
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on }">
                                <a target="_blank" href="/termo" @click.stop v-on="on">Termos de Uso</a>
                              </template>
                              {{$t('pageCadastro.tooltipAba')}}
                            </v-tooltip>e a
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on }">
                                <a
                                  target="_blank"
                                  href="/privacidade"
                                  @click.stop
                                  v-on="on"
                                >Política de Privacidade</a>
                              </template>
                              {{$t('pageCadastro.tooltipAba')}}
                            </v-tooltip>
                          </div>
                        </template>
                      </v-checkbox>
                      <v-btn
                        color="secondary"
                        depressed
                        large
                        @click="verifyEmail"
                        :disabled="!valid"
                      >CONTINUAR</v-btn>
                    </v-row>
                  </v-container>
                </v-form>
              </v-col>
            </v-row>
          </v-stepper-content>

          <v-stepper-content step="2">
            <v-row class="align-center justify-center">
              <v-col class="col-12 col-md-4 ma-0 pa-0">
                <ButtonFoto
                  title="Foto de Perfil"
                  v-bind:email="email"
                  v-on:url-img="saveImgProfile"
                  folder="psicologo"
                  name_img="profileImg"
                />
                <v-select
                  :items="list_language"
                  label="Idioma"
                  @change="getLanguage"
                  :rules="rules"
                  required
                  solo
                  flat
                  background-color="#F7F7F7"
                ></v-select>
              </v-col>
            </v-row>
            <v-row class="align-center justify-center">
              <v-col class="col-12">
                <v-form v-model="valid2" ref="form">
                  <v-container>
                    <v-row class="justify-center">
                      <v-col class="col-12 col-sm-6 col-md-4">
                        <v-text-field
                          solo
                          flat
                          label="Nome Completo"
                          v-model="name"
                          :rules="rules"
                          required
                          background-color="#F7F7F7"
                        ></v-text-field>
                        <v-select
                          :items="list_gender"
                          label="Sexo"
                          @change="getGender"
                          :rules="rules"
                          required
                          solo
                          flat
                          background-color="#F7F7F7"
                        ></v-select>

                        <!-- <v-menu
                                                    ref="menu"
                                                    lazy
                                                    :close-on-content-click="false"
                                                    v-model="menu"
                                                    transition="scale-transition"
                                                    offset-y
                                                    full-width
                                                    :nudge-right="40"
                                                    min-width="290px"
                                                    :return-value.sync="date_birth"
                                                    >
                                                    <v-text-field
                                                        slot="activator"
                                                        label="Data de Nascimento"
                                                        v-model="date"
                                                        solo
                                                        flat
                                                        readonly
                                                        :rules="rules"
                                                        required
                                                        background-color="#F7F7F7"
                                                    ></v-text-field>
                                                    <v-date-picker v-model="date_birth" no-title scrollable>
                                                        <v-spacer></v-spacer>
                                                        <v-btn flat color="primary" @click="menu = false">Cancel</v-btn>
                                                        <v-btn flat color="primary" @click="$refs.menu.save(date_birth)">OK</v-btn>
                                                    </v-date-picker>
                        </v-menu>-->
                        <DatePicker v-on:date="saveDate" />

                        <v-text-field
                          filled
                          flat
                          label="Habilitações Académicas"
                          placeholder="Sou doutoranda e tenho dois mestrados na área de ansiedade infantil."
                          v-model="academic_degree"
                          :rules="rules"
                          required
                          background-color="#F7F7F7"
                          counter
                          maxlength="1024"
                          hint="Atenção: Limite de 1024 caracteres."
                        ></v-text-field>
                      </v-col>
                      <v-col class="col-12 col-sm-6 col-md-4">
                        <v-text-field
                          solo
                          flat
                          label="Nacionalidade"
                          v-model="nation"
                          :rules="rules"
                          required
                          background-color="#F7F7F7"
                        ></v-text-field>
                        <v-autocomplete
                          solo
                          flat
                          hide-no-data
                          clearable
                          label="Fuso horário"
                          :items="time_zone"
                          @change="timeZone"
                          :rules="rules"
                          required
                          background-color="#F7F7F7"
                        ></v-autocomplete>
                        <v-text-field
                          solo
                          flat
                          label="Cidade"
                          v-model="city"
                          :rules="rules"
                          required
                          background-color="#F7F7F7"
                        ></v-text-field>
                        <v-text-field
                          solo
                          flat
                          :label="$t('pageCadastro.labelDestrito')"
                          v-model="state"
                          :rules="rules"
                          required
                          background-color="#F7F7F7"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row class="justify-center">
                      <v-col class="col-12 col-sm-6 col-md-4">
                        <v-text-field
                          v-if="language == 'pt-BR'"
                          solo
                          flat
                          label="Número da CRP"
                          v-model="crp"
                          background-color="#F7F7F7"
                        ></v-text-field>
                        <v-text-field
                          solo
                          flat
                          label="Número da OPP"
                          type="number"
                          v-model="opp"
                          :rules="rules"
                          required
                          background-color="#F7F7F7"
                        ></v-text-field>
                        <v-row class="justify-space-around">
                          <v-col class="col-4 text-center">
                            <ButtonFoto
                              title="Frente da OPP"
                              v-bind:email="email"
                              v-on:url-img="saveImgOppFront"
                              folder="psicologo"
                              name_img="oppFront"
                            />
                          </v-col>
                          <v-col class="col-4 text-center">
                            <ButtonFoto
                              title="Verso da OPP"
                              v-bind:email="email"
                              v-on:url-img="saveImgOppBack"
                              folder="psicologo"
                              name_img="oppBack"
                            />
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col class="col-12 col-sm-6 col-md-4 py-0">
                        <p class="caption mb-0">Valor da Consulta</p>
                        <v-row>
                          <v-col class="col-4">
                            <v-select
                              label="R$"
                              :items="list_symbol"
                              @change="getSymbol"
                              :rules="rules"
                              required
                              solo
                              flat
                              background-color="#F7F7F7"
                            ></v-select>
                          </v-col>
                          <v-col class="col-8">
                            <money v-model="price" v-bind="money"></money>
                          </v-col>
                        </v-row>
                        <v-textarea
                          solo
                          flat
                          label="Biografia"
                          v-model="biography"
                          background-color="#F7F7F7"
                          counter
                          maxlength="1024"
                          hint="Atenção: Limite de 1024 caracteres."
                        ></v-textarea>
                      </v-col>
                    </v-row>
                    <v-row class="flex-column align-center justify-center">
                      <v-btn
                        class="mb-3"
                        color="secondary"
                        depressed
                        large
                        @click="verifyPhotos"
                        :disabled="!valid2"
                      >CONTINUAR</v-btn>
                      <v-btn text>Cancelar</v-btn>
                    </v-row>
                  </v-container>
                </v-form>
              </v-col>
            </v-row>
          </v-stepper-content>

          <v-stepper-content step="3">
            <v-row class="align-center justify-center">
              <v-col class="col-12">
                <v-form>
                  <v-container>
                    <v-row class="justify-center">
                      <v-col class="col-12 col-sm-8">
                        <h2 class="primary--text">Áreas de Atuação</h2>
                        <p class="font-italic">Selecione uma ou mais áreas.</p>
                        <v-row>
                          <v-col
                            class="shrink pa-1 col-auto"
                            v-for="(especiality,index) in types"
                            :key="index"
                          >
                            <v-checkbox
                              class="specialities"
                              v-model="selected"
                              :value="especiality.id"
                              :label="especiality.description"
                            ></v-checkbox>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-form>
              </v-col>
            </v-row>
            <v-row class="flex-column align-center justify-center">
              <v-btn color="secondary" depressed large @click="submit" :loading="loader">FINALIZAR</v-btn>
              <v-btn text to="login">Cancelar</v-btn>
            </v-row>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </v-content>
  </v-app>
</template>

<script>
import http from '@/services/httpClient';
import HeaderSimple from '@/components/HeaderSimple';
import ButtonFoto from '@/components/ButtonFoto';
import DatePicker from '@/components/DatePicker';
import moment from 'moment-timezone';
import { Money } from 'v-money';
import { signUp } from '../../services/psychologists';
import i18n from '../../plugins/i18n';

export default {
  components: {
    HeaderSimple,
    ButtonFoto,
    DatePicker,
    Money,
  },

  data() {
    return {
      valid: false,
      valid2: false,
      loader: false,
      show1: false,
      show2: false,
      edit: false,
      e1: 1,
      photo_profile: '',
      name: '',
      list_gender: ['Masculino', 'Feminino', 'Não Definido'],
      gender: '',
      list_symbol: ['R$', '€'],
      symbol: '',
      list_language: [
        {
          text: 'PT-BR',
          value: 'pt-BR',
        },
        {
          text: 'PT',
          value: 'pt',
        },
      ],
      language: '',
      date: '',
      date_birth: null,
      academic_degree: '',
      biography: '',
      nation: '',
      city: '',
      state: '',
      crp: '',
      opp: '',
      photo_opp_front: '',
      photo_opp_back: '',
      price: '',
      money: {
        precision: 2,
        masked: false,
      },
      time_zone: moment.tz.names(),
      time_offset: '',
      time_zone_name: '',
      email: '',
      check_email: '',
      password: '',
      check_password: '',
      checkbox: false,
      rules: [v => !!v || 'Esse campo é obrigatório'],
      emailRules: [
        v => !!v || 'Email é obrigatório',
        v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v)
          || 'Email está invalido',
      ],
      passwordRules: [
        v => !!v || 'Senha é obrigatória',
        v => /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9]).{8,64}$/.test(v)
          || 'A senha deve conter no mínimo 8 caracteres, letra maiúscula, letra minúscula e número.',
      ],
      snackbar: false,
      msg: '',
      menu: false,
      types: [],
      selected: [],
      page: 1,
    };
  },

  created() {
    this.getSpecialities();
  },

  computed: {
    emailConfirmationRules() {
      return [
        v => !!v || 'Email é obrigatório',
        () => this.email === this.check_email
          || 'Email não corresponde com o informado anteriormente.',
        v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v)
          || 'Email está invalido',
      ];
    },

    senhaConfirmationRules() {
      return [
        v => !!v || 'A senha é obrigatória',
        () => this.password === this.check_password
          || 'A Senha não corresponde com a informada anteriormente.',
        v => /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9]).{8,64}$/.test(v)
          || 'A senha deve conter no mínimo 8 caracteres, letra maiúscula, letra minúscula e número.',
      ];
    },
    moneyRules() {
      return [
        v => !!v || 'Esse campo é obrigatório',
        v => /^(?=.*[0-9]).{5,8}$/.test(v) || 'Digite um valor valido.',
      ];
    },
  },

  watch: {
    language(val) {
      i18n.locale = val;
    },
  },

  methods: {
    timeZone(val) {
      const m = moment().tz(val);
      this.time_offset = m.format('Z');
      this.time_zone_name = val;
    },
    getGender(v) {
      this.gender = v;
    },
    getLanguage(v) {
      this.language = v;
    },
    getSymbol(v) {
      this.symbol = v;
    },
    verifyPhotos() {
      if (
        this.photo_profile == ''
        || this.photo_opp_front == ''
        || this.photo_opp_back == ''
      ) {
        this.snackbar = true;
        this.msg = 'As fotos de perfil e do OPP são obrigatorias!';
      } else {
        this.e1 = 3;
        this.edit = true;
      }
    },

    verifyEmail() {
      http
        .post('/users/check_username/', {
          username: this.email,
        })
        .then((response) => {
          console.log(response.data);
          // this.e1 = 2;
          this.msg = response.data;
          this.snackbar = true;
        })
        .catch((err) => {
          console.log(err.response.data.detail);
          this.e1 = 2;
        });
    },

    async submit() {
      if (this.$refs.form.validate()) {
        this.loader = true;
        await this.signUp();
      }
    },

    signUp() {
      let appointment_br_value = '0';
      let appointment_pt_value = '0';
      if (this.symbol == 'R$') {
        appointment_br_value = this.price;
      } else if (this.symbol == '€') {
        appointment_pt_value = this.price;
      }

      try {
        const data = {
          name: this.name,
          gender: this.gender,
          date_birth: this.date_birth,
          academic_degree: this.academic_degree,
          biography: this.biography,
          country: this.nation,
          city: this.city,
          state: this.state,
          language: this.language,
          crp: this.crp,
          opp: this.opp,
          photo: this.photo_profile,
          opp_front: this.photo_opp_front,
          opp_back: this.photo_opp_back,
          time_zone: this.time_offset,
          time_zone_name: this.time_zone_name,
          email: this.email,
          password: this.password,
          confirm_password: this.check_password,
          appointment_br_value,
          appointment_pt_value,
        };
        signUp(data, this.selected)
          .then((res) => {
            console.log(res);
            this.msg = 'Cadastro Realizado com sucesso!';
            this.snackbar = true;
            setTimeout(() => {
              this.$router.replace('login');
            }, 3000);
          })
          .catch((e) => {
            console.log(e.response.data);
            if (e.response.data.email) {
              this.snackbar = true;
              this.msg = e.response.data.email;
            }
            if (
              e.response.data.appointment_br_value
              || e.response.data.appointment_pt_value
            ) {
              this.snackbar = true;
              this.msg = e.response.data.appointment_br_value
                ? e.response.data.appointment_br_value[0]
                : e.response.data.appointment_pt_value[0];
            }
          })
          .finally(() => (this.loader = false));
      } catch (e) {
        console.log(e);
      } finally {
        this.loader = false;
      }
    },

    getSpecialities() {
      http
        .get('/specialities/', {
          params: {
            page: this.page,
          },
        })
        .then((res) => {
          for (const item of res.data.results) {
            this.types.push(item);
          }
          if (res.data.next != null) {
            this.page = this.page + 1;
            this.getSpecialities();
          }
          // console.log(this.types);
        });
    },

    // gettanggal: function(str) {
    //     if (str != null) {
    //         return str.substring(8, 10)+'/'+str.substring(5, 7)+'/'+str.substring(0, 4);
    //     }
    //     return '';
    // },

    saveImgProfile(value) {
      this.photo_profile = value;
    },

    saveImgOppFront(value) {
      this.photo_opp_front = value;
    },

    saveImgOppBack(value) {
      this.photo_opp_back = value;
    },

    saveDate(value) {
      this.date_birth = value;
    },
  },
};
</script>

<style scoped>
* >>> .specialities {
  margin-top: 0px;
}

* >>> .specialities .v-input--selection-controls__input {
  display: none;
}

*
  >>> .specialities.v-input--selection-controls:not(.v-input--hide-details)
  .v-input__slot {
  margin-bottom: 0;
  background: #ffffff;
  border: 2px solid #02a554;
  padding: 8px 16px;
  border-radius: 23px;
}
* >>> .specialities.v-input--selection-controls.v-input .v-label {
  color: #02a554;
}
* >>> .specialities.v-input--is-label-active .v-input__control .v-input__slot {
  background: #02a554;
}

*
  >>> .specialities.v-input--is-label-active.v-input--selection-controls.v-input
  .v-label {
  color: #ffffff;
}

* >>> .v-input__slot:after {
  display: none;
}

* >>> .v-input__slot:before {
  display: none;
}
.v-money {
  height: 48px;
  width: 100%;
  background-color: rgb(247, 247, 247);
  border-radius: 4px;
  padding: 10px;
  caret-color: #93291e;
}
.v-money:focus {
  outline-offset: unset;
  outline: none;
}
</style>
